import { FC, Fragment } from 'react';
import { FieldRenderProps } from 'react-final-form';

type TableFilterSelectFieldProps = FieldRenderProps<
  string,
  HTMLElement,
  string
> & {
  labelText?: string;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  options: any[];
};

const TableFilterSelectField: FC<TableFilterSelectFieldProps> = ({
  input,
  labelText,
  options,
  renderOption,
  ...otherProps
}) => {
  return (
    <div className="relative w-full">
      <label
        className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs font-medium text-gray-500"
        htmlFor={input.name}
      >
        {labelText || input.name}
      </label>
      <select
        id={input.name}
        className="block w-full rounded-md border-gray-300 text-sm shadow-sm"
        {...input}
        {...otherProps}
      >
        <option value="" />
        {options &&
          options.map((option, i) => {
            return <Fragment key={i}>{renderOption(option)}</Fragment>;
          })}
      </select>
    </div>
  );
};

export default TableFilterSelectField;
